export const WORKDAY_RESET = 'workday@reset';
export const WORKDAY_SET = 'workday@set-details';
export const WORKDAY_START = 'workday@start';
export const WORKDAY_FINISH = 'workday@finish';
export const WORKDAY_START_BREAK = 'workday@break-start';
export const WORKDAY_START_LUNCH = 'workday@lunch-start';
export const WORKDAY_FINISH_BREAK = 'workday@break-finish';
